import _classCallCheck from "C:/Users/user/Documents/techedge/Sorgenia/profilocarico_webapp/ProfiloDiCarico/ProfiloDiCarico.Web/client-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/user/Documents/techedge/Sorgenia/profilocarico_webapp/ProfiloDiCarico/ProfiloDiCarico.Web/client-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "C:/Users/user/Documents/techedge/Sorgenia/profilocarico_webapp/ProfiloDiCarico/ProfiloDiCarico.Web/client-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "C:/Users/user/Documents/techedge/Sorgenia/profilocarico_webapp/ProfiloDiCarico/ProfiloDiCarico.Web/client-app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { formatOffset as _formatOffset, signedOffset } from "../impl/util.js";
import Zone from "../zone.js";
var singleton = null;

/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */
var FixedOffsetZone = /*#__PURE__*/function (_Zone) {
  _inherits(FixedOffsetZone, _Zone);
  var _super = _createSuper(FixedOffsetZone);
  function FixedOffsetZone(offset) {
    var _this;
    _classCallCheck(this, FixedOffsetZone);
    _this = _super.call(this);
    /** @private **/
    _this.fixed = offset;
    return _this;
  }

  /** @override **/
  _createClass(FixedOffsetZone, [{
    key: "type",
    get: function get() {
      return "fixed";
    }

    /** @override **/
  }, {
    key: "name",
    get: function get() {
      return this.fixed === 0 ? "UTC" : "UTC".concat(_formatOffset(this.fixed, "narrow"));
    }
  }, {
    key: "ianaName",
    get: function get() {
      if (this.fixed === 0) {
        return "Etc/UTC";
      } else {
        return "Etc/GMT".concat(_formatOffset(-this.fixed, "narrow"));
      }
    }

    /** @override **/
  }, {
    key: "offsetName",
    value: function offsetName() {
      return this.name;
    }

    /** @override **/
  }, {
    key: "formatOffset",
    value: function formatOffset(ts, format) {
      return _formatOffset(this.fixed, format);
    }

    /** @override **/
  }, {
    key: "isUniversal",
    get: function get() {
      return true;
    }

    /** @override **/
  }, {
    key: "offset",
    value: function offset() {
      return this.fixed;
    }

    /** @override **/
  }, {
    key: "equals",
    value: function equals(otherZone) {
      return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    }

    /** @override **/
  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }], [{
    key: "utcInstance",
    get:
    /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */
    function get() {
      if (singleton === null) {
        singleton = new FixedOffsetZone(0);
      }
      return singleton;
    }

    /**
     * Get an instance with a specified offset
     * @param {number} offset - The offset in minutes
     * @return {FixedOffsetZone}
     */
  }, {
    key: "instance",
    value: function instance(offset) {
      return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    }

    /**
     * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
     * @param {string} s - The offset string to parse
     * @example FixedOffsetZone.parseSpecifier("UTC+6")
     * @example FixedOffsetZone.parseSpecifier("UTC+06")
     * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
     * @return {FixedOffsetZone}
     */
  }, {
    key: "parseSpecifier",
    value: function parseSpecifier(s) {
      if (s) {
        var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
        if (r) {
          return new FixedOffsetZone(signedOffset(r[1], r[2]));
        }
      }
      return null;
    }
  }]);
  return FixedOffsetZone;
}(Zone);
export { FixedOffsetZone as default };